<template>
  <div class="form-field">
    <label v-if="label">{{ label }}:</label>
    <div class="select">
      <div
        class="select__selected"
        id="pad-select"
        pad-down="go:#pad-select-option,#pad-play,#pad-get-game"
        pad-right="go:#pad-banner"
        pad-up="go:#pad-home"
        pad-a="click"
        tabindex="1"
        @click="toggle"
        v-click-outside="hide"
      >
        {{ selectedValue.label }}
        <iconDropdown />
      </div>

      <div v-if="isExpanded" class="select__options">
        <div
          v-for="option in filteredOptions"
          :key="option.code"
          class="select__option"
          @click="emitSelectedValue(option)"
          id="pad-select-option"
          pad-up="go:#pad-select"
          pad-a="click"
          tabindex="1"
        >
          {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconDropdown from "@/components/Icons/iconDropdown";
import ClickOutside from "vue-click-outside";

export default {
  components: {
    iconDropdown
  },

  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },

    selectedValue: {
      type: Object
    }
  },

  data() {
    return {
      isExpanded: false
    };
  },

  computed: {
    filteredOptions() {
      return this.options.filter(item => {
        return item.code !== this.selectedValue.code;
      });
    }
  },

  methods: {
    emitSelectedValue(data) {
      this.$emit("selectedValue", data);
      this.hide();
      document.pad.focus("#pad-select");
    },

    expand() {
      this.isExpanded = true;
    },
    hide() {
      this.isExpanded = false;
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
    }
  },
  directives: {
    ClickOutside
  }
};
</script>

<style lang="scss" scoped>
.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

label {
  font-size: 12px;
  line-height: 1;
  color: $white;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.select {
  border-radius: 0;
  background: $black-60;
  height: 50px;
  padding: 0;
  color: $white;
  position: relative;
  cursor: pointer;
  z-index: 10;
}

.select__selected {
  color: $white;
  opacity: 1;
  padding: 0 0 0 22px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border: 2px solid $white-40;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: $yellow;
  }

  svg {
    margin-left: auto;
    margin-right: 20px;
  }
}

.select__options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 50px;
}

.select__option {
  width: 100%;
  height: 100%;
  background: $dark-grey;
  padding: 0 0 0 22px;
  display: flex;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: $graphite;
  }
}
</style>
